import { call, put, select } from 'redux-saga/effects';
import { request } from '../../xhr';
import { actions, selectors } from '../../Stream';
import { getCurrentMediaSource, getCurrentStreamId, getCurrentGallection, getCurrentSubfolderId } from '../selectors';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
import { MediaSourceType } from '../types';
import { getGallectionType } from '../helpers';
function* moveDeviationToPosition(action) {
    const { deviation , position , moveType  } = action.payload;
    const { streamId , currentMediaSource , currentGallection , currentSubfolderId  } = yield select((state)=>({
            streamId: getCurrentStreamId(state),
            currentMediaSource: getCurrentMediaSource(state),
            currentGallection: getCurrentGallection(state),
            currentSubfolderId: getCurrentSubfolderId(state)
        }));
    const isFetching = yield select(selectors.isFetching, streamId);
    if (!moveType || moveType === 'streamOnly') {
        if (currentMediaSource !== MediaSourceType.CUSTOM_SET && isFetching) {
            return;
        }
        yield put(actions.moveItem({
            streamId,
            item: getDeviationEntityId(deviation),
            position
        }));
    }
    if (currentMediaSource === MediaSourceType.CUSTOM_SET) {
        return;
    }
    if (!moveType || moveType === 'papiOnly') {
        if (!currentGallection) {
            return;
        }
        var _getGallectionType;
        const data = {
            type: (_getGallectionType = getGallectionType(currentGallection)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'collection',
            folderid: currentSubfolderId || currentGallection.folderId,
            deviationid: deviation.deviationId,
            position
        };
        yield call(request, {
            method: 'post',
            url: 'gallection/folders/update_deviation_order',
            data
        });
    }
}
export default moveDeviationToPosition;
